import { useState, useEffect, useCallback } from 'react';

/**
 * Hook that tracks the browser's online/offline status.
 * Listens to `online` and `offline` window events and exposes
 * a manual `recheckStatus` helper for retry flows.
 */
export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  const recheckStatus = useCallback(() => {
    setIsOnline(navigator.onLine);
    return navigator.onLine;
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline, recheckStatus };
}
